<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PsotAddMain from "@/views/StockManagement/PsotManage/TabChild/PsotAddMain";

export default {
  name: "PsotAdd",
  components: {
    childTab1: PsotAddMain
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>